import React from "react";
import CorrectSummary from "components/Question/Listening/CorrectSummary";
import Dictation from "components/Question/Listening/Dictation";
import Highlight from "components/Question/Listening/Highlight";
import ListeningBlank from "components/Question/Listening/ListeningBlank";
import McqMulti from "components/Question/Listening/McqMulti";
import McqSingle from "components/Question/Listening/McqSingle";
import MissingWord from "components/Question/Listening/MissingWord";
import Summer from "components/Question/Listening/Summer";
import MultipleAnswer from "components/Question/Reading/MultipleAnswer";
import ReadingBlank from "components/Question/Reading/ReadingBlank";
import Reorder from "components/Question/Reading/Reorder";
import SingleAnswer from "components/Question/Reading/SingleAnswer";
import WrittingBlank from "components/Question/Reading/WrittingBlank";
import RetellLec from "components/Question/Speaking/RetellLec";
import ShortQue from "components/Question/Speaking/ShortQue";
import Essay from "components/Question/Writting/Essay";
import Summary from "components/Question/Writting/Summary";
import ReadAloud from "components/Question/Speaking/ReadAloud.jsx";
import DescribeImage from "components/Question/Speaking/DescribeImage.jsx";
import RepeatSentece from "components/Question/Speaking/RepeatSentece.jsx";
import Skeleton from "react-loading-skeleton";
import { CardBody, Row } from "reactstrap";

const Section = ({ mockData, data }) => {
  let que;
  let title = "";
  let quesTitle = "";
  if (mockData.questionData.length > 0) {
    quesTitle = mockData.questionData[mockData.currentQuestion].qTitle;
  }

  let questionTime = 0;
  if (data.questionTime && data.isQuestionTime) {
    questionTime = Math.floor(data.questionTime);
  }

  switch (mockData.type) {
    case 1:
      que = <ReadAloud {...data} />;
      title =
        "Look at the text below. In the 35 seconds, you must read this text aloud as naturally and clearly as possible. You have 35 seconds to read aloud.";
      break;
    case 2:
      que = <RepeatSentece {...data} />;
      title =
        "You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.";
      break;
    case 3:
      que = <DescribeImage {...data} />;
      title =
        "Look at the Image below. In 25 seconds,please speak into the microphone and describe in detail what the graph showing. You will have 40 seconds to give your response.";
      break;
    case 4:
      que = <RetellLec {...data} />;
      title =
        "Listen to and read a description of a situation. You will have 20 seconds to think about your answer. Then you will hear a beep. You will have 40 seconds to answer the question. Please answer as completely as you can.";
      break;
    case 5:
      que = <ShortQue {...data} />;
      title =
        "You will hear a question. Please give a simple and short answer. Often just one or a few words is enough.";
      break;
    case 6:
      que = <Summary {...data} />;
      title =
        "Read the passage below. Summarize the passage using between 25 and 50 words. Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. Your response will be judged on the quality of your writing and on how well your response presents the key points in the passage.";
      break;
    case 7:
      que = <Essay {...data} />;
      title =
        "Read a description of a situation. Then write an email about the situation. You will have " +
        (questionTime ? questionTime : "20") +
        " minutes. You should aim to write at least 100 words.";
      break;
    case 8:
      que = <SingleAnswer {...data} />;
      title =
        "Read the text and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
      break;
    case 9:
      que = <MultipleAnswer {...data} />;
      title =
        "Read the text and answer the question by selecting all the correct responses. More than one response is correct.";
      break;
    case 10:
      que = <Reorder {...data} />;
      title =
        "The textbox in the left panel have been placed in a random order. Restore the original order by dragging the text boxes from the left panel to the right panel.";
      break;
    case 11:
      que = <ReadingBlank {...data} />;
      title =
        "In the text below some words are missing. Drag words from the text box below to the appropriate place in the text. To undo an answer choice, drag the word back to the box below the text.";
      break;
    case 12:
      que = <WrittingBlank {...data} />;
      title =
        "Below is a text with blanks. Click on each blank, a list of choices will appear. Select the appropriate answer choice for each blank.";
      break;
    case 13:
      que = <Summer {...data} />;
      title =
        "You will hear a short lecture. Write a summary for a fellow student who was not present at the lecture. You should write 20-30 words. You have " +
        (questionTime ? questionTime : "10") +
        " minutes to finish the task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the lecture.";
      break;
    case 14:
      que = <McqSingle {...data} />;
      title =
        "Listen to the recording and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
      break;
    case 15:
      que = <McqMulti {...data} />;
      title =
        "Listen to the recording and answer the question by selecting all the correct responses. You will need to select more than one response.";
      break;
    case 16:
      que = <ListeningBlank {...data} />;
      title =
        "You will hear a recording. Type the missing words in each blank.";
      break;
    case 17:
      que = <CorrectSummary {...data} />;
      title =
        "You will hear a recording. Click on the paragraph that best relates to the recording.";
      break;
    case 18:
      que = <MissingWord {...data} />;
      title =
        "You will hear a recording about " +
        quesTitle +
        ". At the end of the recording the last word or group of words has benn replaced by a beep. Select the correct option to complete the recording";
      break;
    case 19:
      que = <Highlight {...data} />;
      title =
        "You will hear a recording. Below is a transcription of the recording. Some words in the transcription differ from what the speaker(s) said. Please click on the words that are different.";
      break;
    case 20:
      que = <Dictation {...data} />;
      title =
        "You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once.";
      break;
    default:
    // code block
  }

  return (
    <>
      <CardBody>
        <h4>{title}</h4>
        <Row className="unselectable">
          {mockData.secondCount === 0 && (
            <div>Test stopped due to timeout.</div>
          )}
          {mockData.internet ? (
            mockData.secondCount !== 0 && mockData.questionData && que
          ) : (
            <>
              <Skeleton
                count={1}
                width={"50%"}
                height={200}
                containerClassName="skeleton-wrapper__mockrecording"
              />
              <Skeleton
                count={5}
                width={"100%"}
                containerClassName="skeleton-wrapper__mocklines"
              />
            </>
          )}
        </Row>
      </CardBody>
    </>
  );
};

export default Section;
